/* Store drawer shared by the Contact page and the product page (snippets/ll-store-drawer.liquid). Final design 20 Oct 2026: full-bleed gallery
   (the store photo, or a clean placeholder until one is attached, with an on-request "How far is it?" chip; then the interactive map), name,
   rows (address, phone, Click and collect, hours dropdown with a green/red live status), and a pinned Directions footer.
   Stores come from the editor's Stores list as JSON: { n, a, h, q, cc, p, ps, t, w, s, c }  (s/c = the product page's stock text / "no").
   Each drawer is mounted on load; the controller sits on the element: document.getElementById(id).__sd = { stores, open(opener, { hours }), close(), show(i), onpick }. */
(() => {
  const DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'], DAYNAME = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const DOM_Q = '-36.878131,174.7503374'; // Dominion Rd, Mt Eden
  const DEFAULT_WEEK = 'Mon–Thu 11am–8pm\nFri–Sat 11am–8:55pm\nSun 11am–8pm'; // Google, 19 Oct 2026: used until the editor's week is filled in
  const norm = (d) => { if (d.q === DOM_Q) { d.w = d.w || DEFAULT_WEEK; d.t = d.t || '09 623 1903'; } return d; };

  const nzNow = () => {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'Pacific/Auckland', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date()).map((x) => [x.type, x.value]));

    return { d: DAYS.indexOf(p.weekday.slice(0, 3).toLowerCase()), m: (+p.hour % 24) * 60 + +p.minute };
  };
  const daysOf = (txt) => {
    const s = txt.toLowerCase();
    if (/daily|every ?day|7 days/.test(s)) return [0, 1, 2, 3, 4, 5, 6];
    const t = [...s.matchAll(/\b(sun|mon|tue|wed|thu|fri|sat)[a-z]*/g)].map((m) => DAYS.indexOf(m[1]));
    if (t.length !== 2 || !/[–—-]|\bto\b/.test(s)) return t;
    const out = [];
    for (let d = t[0]; ; d = (d + 1) % 7) { out.push(d); if (d === t[1]) break; }
    return out;
  };
  const clock = (h, m, ap) => (ap.toLowerCase() === 'pm' ? (h % 12) + 12 : h % 12) * 60 + (+m || 0);
  const parseWeek = (w) => (w || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean).map((line) => {
    const m = line.match(/^(.*?)[\s:,–—-]*(\d.*|closed.*)$/i);
    if (!m || !/[a-z]/i.test(m[1])) return { line };
    const row = { label: m[1].trim(), time: m[2].trim(), days: daysOf(m[1]) };
    const t = m[2].match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)?\s*[–—-]\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)/i);
    if (t) {
      const ap = t[3] || t[6];
      Object.assign(row, { o: clock(+t[1], t[2], ap), c: clock(+t[4], t[5], t[6]), oT: `${t[1]}${t[2] ? ':' + t[2] : ''}${ap.toLowerCase()}`, cT: `${t[4]}${t[5] ? ':' + t[5] : ''}${t[6].toLowerCase()}` });
    }
    return row;
  });
  // live line in NZ time; null when no week parses (callers then fall back to the editor's short hours text)
  const statusOf = (d) => {
    d = norm(d);
    const rows = parseWeek(d.w).filter((r) => r.o !== undefined && r.c > r.o), now = nzNow();
    if (!rows.length) return null;
    const on = (day) => rows.find((r) => r.days.includes(day));
    const t = on(now.d);
    if (t && now.m < t.o) return { open: false, label: 'Closed', rest: `opens ${t.oT}`, text: `Closed · opens ${t.oT}` };
    if (t && now.m < t.c) return { open: true, label: 'Open now', rest: `closes ${t.cT}`, text: `Open now · closes ${t.cT}` };
    for (let k = 1; k <= 7; k++) {
      const n = on((now.d + k) % 7);
      if (n) { const rest = `opens ${n.oT}${k === 1 ? '' : ' ' + DAYNAME[(now.d + k) % 7]}`; return { open: false, label: 'Closed', rest, text: `Closed · ${rest}` }; }
    }
    return null;
  };
  // great-circle distance in km (haversine)
  const km = (la1, lo1, la2, lo2) => {
    const r = (x) => (x * Math.PI) / 180, a = Math.sin(r(la2 - la1) / 2) ** 2 + Math.cos(r(la1)) * Math.cos(r(la2)) * Math.sin(r(lo2 - lo1) / 2) ** 2;
    return 12742 * Math.asin(Math.sqrt(a));
  };
  const coords = (q) => { const m = /^(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)$/.exec(q || ''); return m ? [+m[1], +m[2]] : null; };
  window.LLStore = { statusOf, norm, km };

  const mapSrc = (q) => `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=15&output=embed`;
  const dirUrl = (q) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(q)}`;
  const telUrl = (t) => 'tel:' + t.replace(/[^\d+]/g, '');
  const el = (tag, cls, text) => { const x = document.createElement(tag); if (cls) x.className = cls; if (text) x.textContent = text; return x; };
  const ORDER = [1, 2, 3, 4, 5, 6, 0]; // Monday first
  const PIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11a7 7 0 0114 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>';
  const SHOP = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M6 20l3-10h30l3 10M6 20h36M8 20v20h32V20M20 40V28h8v12M14 24h2M32 24h2"/><path d="M6 20c0 3 2.5 4.5 4.5 4.5S15 23 15 20c0 3 2.5 4.5 4.5 4.5S24 23 24 20c0 3 2.5 4.5 4.5 4.5S33 23 33 20c0 3 2.5 4.5 4.5 4.5S42 23 42 20"/></svg>';

  const mount = (dr) => {
    const f = (k) => dr.querySelector(`[data-f="${k}"]`), scrim = dr.previousElementSibling;
    const stores = JSON.parse(dr.querySelector('script[data-sd-json]').textContent).map(norm), cfg = JSON.parse(dr.querySelector('script[data-sd-cfg]').textContent);
    const track = f('track'), dots = f('dots');
    let cur = 0, opener = null, expanded = false;
    const ctl = { stores, onpick: null };

    // gallery: the store photo(s) (a clean placeholder until one is attached), then the interactive map
    const goSlide = (n) => track.scrollTo({ left: Math.max(0, Math.min(track.children.length - 1, n)) * track.clientWidth, behavior: 'smooth' });
    const slideNow = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
    const markDot = () => { const n = slideNow(); [...dots.children].forEach((x, i) => x.classList.toggle('on', i === n)); f('cnt').textContent = `${n + 1} / ${track.children.length}`; };
    const farChip = (d) => { // distance on request only: the browser asks for location when this is clicked, never on load
      const to = coords(d.q); if (!to) return null;
      const b = el('button', 'sd-far'), label = el('span', '', cfg.far); b.type = 'button'; b.innerHTML = PIN; b.append(label);
      b.addEventListener('click', () => {
        if (b.dataset.busy) return; b.dataset.busy = '1';
        const reset = (t, ms) => { label.textContent = t; setTimeout(() => { label.textContent = cfg.far; delete b.dataset.busy; }, ms); };
        if (!navigator.geolocation) return reset(cfg.off, 3000);
        label.textContent = '…';
        navigator.geolocation.getCurrentPosition((p) => {
          const k = km(p.coords.latitude, p.coords.longitude, to[0], to[1]);
          label.textContent = `${k < 10 ? k.toFixed(1) : Math.round(k)} km ${cfg.away}`; delete b.dataset.busy;
        }, () => reset(cfg.off, 3000), { timeout: 10000, maximumAge: 300000 });
      });
      return b;
    };
    const buildGallery = () => {
      if (track.dataset.i === String(cur)) return;
      track.dataset.i = cur; track.textContent = ''; dots.textContent = '';
      const d = stores[cur], seen = new Set();
      const photos = [d.p, ...(d.ps || '').split(/\r?\n/)].map((u) => (u || '').trim()).filter((u) => /^https?:\/\//i.test(u) && !seen.has(u) && seen.add(u));
      const slides = [];
      if (photos.length) photos.forEach((u, i) => { const s = el('div', 'gal-s'), img = el('img'); img.src = u; img.alt = i ? '' : d.n; img.draggable = false; img.loading = i ? 'lazy' : 'eager'; s.append(img); slides.push(s); });
      else { const s = el('div', 'gal-s gal-ph'); s.innerHTML = SHOP; s.append(el('span', '', cfg.photoSoon)); slides.push(s); }
      const chip = farChip(d); if (chip) slides[0].append(chip);
      const ms = el('div', 'gal-s'), ifr = document.createElement('iframe');
      ifr.title = d.n; ifr.loading = 'lazy'; ifr.referrerPolicy = 'no-referrer-when-downgrade'; ifr.src = mapSrc(d.q);
      ms.append(ifr, el('i', 'edge l'), el('i', 'edge r')); slides.push(ms); // the strips at the edges swipe; the middle pans and zooms the map
      slides.forEach((s, n) => { track.append(s); const dot = el('button'); dot.type = 'button'; dot.setAttribute('aria-label', n === slides.length - 1 ? cfg.map : cfg.photo); dot.addEventListener('click', () => goSlide(n)); dots.append(dot); });
      track.scrollLeft = 0; markDot();
    };
    track.addEventListener('scroll', markDot, { passive: true });
    f('prev').addEventListener('click', () => goSlide(slideNow() - 1));
    f('next').addEventListener('click', () => goSlide(slideNow() + 1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') goSlide(slideNow() + 1); else if (e.key === 'ArrowLeft') goSlide(slideNow() - 1); });
    let drag = null; // touch swipes natively (scroll-snap); the mouse drags, a 50px pull turns the page
    track.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' && !e.target.closest('button')) { drag = { x: e.clientX, l: track.scrollLeft, i: slideNow(), dx: 0 }; track.setPointerCapture(e.pointerId); track.classList.add('drag'); } });
    track.addEventListener('pointermove', (e) => { if (drag) { drag.dx = e.clientX - drag.x; track.scrollLeft = drag.l - drag.dx; } });
    const dragEnd = () => { if (!drag) return; const k = drag; drag = null; track.classList.remove('drag'); goSlide(Math.abs(k.dx) > 50 ? k.i + (k.dx < 0 ? 1 : -1) : k.i); };
    track.addEventListener('pointerup', dragEnd); track.addEventListener('pointercancel', dragEnd);

    // hours: one row with the live status that opens to the seven days; the gallery shrinks while it is open so nothing overflows
    const setFold = (on) => { expanded = on; f('hbtn').setAttribute('aria-expanded', on); f('fold').classList.toggle('open', on); dr.classList.toggle('hrs-open', on); };
    const fillHours = (d) => {
      const rows = parseWeek(d.w), list = f('hrs'), today = nzNow().d, st = statusOf(d), box = f('st'), btn = f('hbtn');
      list.textContent = ''; box.textContent = '';
      btn.classList.toggle('open', !!st && st.open); btn.classList.toggle('shut', !!st && !st.open);
      if (st) { box.append(el('b', st.open ? 'sd-ok' : 'sd-no', st.label), document.createTextNode(` · ${st.rest}`)); } else box.textContent = d.h || btn.dataset.soon;
      const dated = rows.filter((r) => r.label && r.days.length);
      btn.disabled = !rows.length; f('chev').hidden = !rows.length;
      if (!rows.length) { setFold(false); return; }
      ORDER.forEach((k) => {
        const r = dated.find((x) => x.days.includes(k));
        if (!r) return;
        const line = el('div', k === today ? 'today' : ''); line.append(el('span', '', DAYNAME[k]), el('span', 'sd-time', r.time)); list.append(line);
      });
      rows.filter((r) => !r.label || !r.days.length).forEach((r) => list.append(el('div', '', r.line || `${r.label} ${r.time}`)));
    };
    const fillList = () => {
      const list = f('list'); list.hidden = stores.length < 2; list.textContent = '';
      stores.forEach((d, i) => {
        const b = el('button', 'pk-srow' + (i === cur ? ' on' : '')), t = el('span');
        b.type = 'button'; b.dataset.i = i; b.disabled = d.c === 'no';
        t.append(el('b', '', d.n), el('small', '', d.a)); b.append(el('i', 'pk-live ' + (d.c || '')), t, el('small', '', d.s || ''));
        list.append(b);
      });
    };
    const fill = () => {
      const d = stores[cur];
      buildGallery();
      f('n').textContent = d.n; f('a').textContent = d.a;
      f('phbox').hidden = !d.t; if (d.t) { f('ph').textContent = d.t; f('phbox').href = telUrl(d.t); }
      f('ccbox').hidden = !d.cc && !d.s; f('stock').hidden = !d.s; f('stock').textContent = d.s || '';
      f('dir').href = dirUrl(d.q);
      fillHours(d); fillList();
    };

    ctl.show = (i) => { cur = i; if (dr.classList.contains('on')) fill(); };
    const focusables = () => [...dr.querySelectorAll('a[href],button')].filter((x) => !x.disabled && !x.closest('[hidden]'));
    const set = (on, from, o) => {
      if (on) { opener = from; fill(); setFold(false); } // hours always start folded (Deep, 20 Oct)
      dr.classList.toggle('on', on); scrim.classList.toggle('on', on); dr.setAttribute('aria-hidden', !on);
      document.body.style.overflow = on ? 'hidden' : '';
      if (on) f('x').focus({ preventScroll: true }); else if (opener) opener.focus({ preventScroll: true });
    };
    ctl.open = (from, o) => set(true, from, o);
    ctl.close = () => set(false);
    f('hbtn').addEventListener('click', () => setFold(!expanded));
    dr.addEventListener('click', (e) => {
      const r = e.target.closest('.pk-srow');
      if (r && !r.disabled) { cur = +r.dataset.i; fill(); if (ctl.onpick) ctl.onpick(cur); }
    });
    document.addEventListener('click', (e) => { if (e.target.closest('[data-sd-close]') && dr.classList.contains('on')) set(false); });
    document.addEventListener('keydown', (e) => {
      if (!dr.classList.contains('on')) return;
      if (e.key === 'Escape') set(false);
      else if (e.key === 'Tab') { // keep focus inside the open drawer
        const k = focusables(), first = k[0], last = k[k.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    dr.__sd = ctl;
  };
  document.querySelectorAll('aside[data-sd-root]').forEach((dr) => dr.__sd || mount(dr)); // the script loads once per drawer on a page
})();
